import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { VerifyEmailClient } from '@/components/auth/verify-email-client';

export const Route = createFileRoute('/_auth/verify-email')({
  validateSearch: (search: Record<string, unknown>): { token: string } => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: VerifyEmailPage,
});

function VerifyEmailPage(): React.ReactElement {
  const { token } = Route.useSearch();
  return (
    <section className="border-border bg-card rounded-2xl border p-8 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
      <VerifyEmailClient token={token} />
    </section>
  );
}
